export const packageList = [
  {
    id: 1,
    nameZh: '365天100G港澳通用',
    nameEn: '100GB 365 Days Valid in HK & Macao',
    data: '100GB',
    daysTagZh: '365天',
    daysTagEn: '365 Days',
    periodTextZh: '套餐有效期365天',
    periodTextEn: 'Valid for 365 days',
    price: '899'
  },
  {
    id: 2,
    nameZh: '180天50G港澳通用',
    nameEn: '50GB 180 Days Valid in HK & Macao',
    data: '50GB',
    daysTagZh: '180天',
    daysTagEn: '180 Days',
    periodTextZh: '套餐有效期180天',
    periodTextEn: 'Valid for 180 days',
    price: '499'
  },
  {
    id: 3,
    nameZh: '90天30G港澳通用',
    nameEn: '30GB 90 Days Valid in HK & Macao',
    data: '30GB',
    daysTagZh: '90天',
    daysTagEn: '90 Days',
    periodTextZh: '套餐有效期90天',
    periodTextEn: 'Valid for 90 days',
    price: '299'
  },
  {
    id: 4,
    nameZh: '30天10G港澳通用',
    nameEn: '10GB 30 Days Valid in HK & Macao',
    data: '10GB',
    daysTagZh: '30天',
    daysTagEn: '30 Days',
    periodTextZh: '套餐有效期30天',
    periodTextEn: 'Valid for 30 days',
    price: '108'
  }
]